import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { TID } from "../../constants/testIds";
import {
  LayoutDashboard, Users, GraduationCap, BookOpen, Calendar,
  CalendarDays, ClipboardList, CheckSquare, Wallet, Receipt,
  Image as ImageIcon, LogOut, Settings, Sparkles,
} from "lucide-react";

const items = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true, testId: TID.adminSidebarDashboard },
  { to: "/admin/students", label: "Schüler", icon: Users, testId: TID.adminSidebarStudents },
  { to: "/admin/teachers", label: "Lehrpersonen", icon: GraduationCap, testId: TID.adminSidebarTeachers },
  { to: "/admin/departments", label: "Fachbereiche", icon: Sparkles, testId: "admin-sb-departments" },
  { to: "/admin/courses", label: "Kurse", icon: BookOpen, testId: TID.adminSidebarCourses },
  { to: "/admin/workshops", label: "Workshops", icon: Calendar, testId: TID.adminSidebarWorkshops },
  { to: "/admin/events", label: "Events", icon: CalendarDays, testId: TID.adminSidebarEvents },
  { to: "/admin/enrollments", label: "Anmeldungen", icon: ClipboardList, testId: TID.adminSidebarEnrollments },
  { to: "/admin/attendance", label: "Anwesenheit", icon: CheckSquare, testId: TID.adminSidebarAttendance },
  { to: "/admin/payments", label: "Zahlungen", icon: Wallet, testId: TID.adminSidebarPayments },
  { to: "/admin/monthly-billing", label: "Monatsbeiträge", icon: Wallet, testId: "admin-sb-monthly-billing" },
  { to: "/admin/settlements", label: "Abrechnungen", icon: Receipt, testId: TID.adminSidebarSettlements },
  { to: "/admin/gallery", label: "Galerie", icon: ImageIcon, testId: TID.adminSidebarGallery },
];

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/admin/login"); };

  return (
    <div className="min-h-screen bg-background text-foreground flex">
      <aside className="w-64 border-r border-border bg-card/40 flex-col hidden lg:flex">
        <div className="px-6 py-6 border-b border-border">
          <div className="font-serif-display text-xl">KK Academy</div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Verwaltung</div>
        </div>
        <nav className="flex-1 overflow-y-auto py-4">
          {items.map(it => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={it.testId}
              className={({ isActive }) =>
                `flex items-center gap-3 px-6 py-2.5 text-sm border-l-2 transition-colors ${isActive ? "border-primary bg-primary/5 text-primary" : "border-transparent text-muted-foreground hover:text-foreground hover:bg-secondary/40"}`
              }
            >
              <it.icon className="w-4 h-4" />{it.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-border p-4">
          <div className="text-xs text-muted-foreground mb-2 truncate">{user?.email}</div>
          <button onClick={doLogout} data-testid={TID.adminLogoutBtn} className="w-full inline-flex items-center justify-center gap-2 py-2 text-xs border border-border rounded-md hover:border-primary hover:text-primary transition-colors">
            <LogOut className="w-3.5 h-3.5" /> Abmelden
          </button>
        </div>
      </aside>
      <div className="flex-1 min-w-0 flex flex-col">
        <header className="h-14 border-b border-border flex items-center justify-between px-6">
          <div className="text-sm text-muted-foreground">Admin Bereich</div>
          <div className="flex items-center gap-3">
            <div className="text-xs text-muted-foreground">{user?.role}</div>
            <button onClick={doLogout} className="lg:hidden inline-flex items-center gap-2 text-xs border border-border rounded-md px-3 py-1.5 hover:border-primary"><LogOut className="w-3.5 h-3.5" />Abmelden</button>
          </div>
        </header>
        {/* mobile nav */}
        <div className="lg:hidden border-b border-border overflow-x-auto">
          <div className="flex">
            {items.map(it => (
              <NavLink key={it.to} to={it.to} end={it.end} className={({ isActive }) => `whitespace-nowrap px-4 py-2 text-xs ${isActive ? "text-primary border-b-2 border-primary" : "text-muted-foreground"}`}>
                {it.label}
              </NavLink>
            ))}
          </div>
        </div>
        <main className="flex-1 overflow-y-auto p-6"><Outlet /></main>
      </div>
    </div>
  );
};

export default AdminLayout;
